var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectApps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7987 47.46H13.9688V48.28H41.7987V47.46Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1497 27.7002H38.6097C38.8006 27.7002 38.9838 27.7761 39.1188 27.9111C39.2538 28.0461 39.3297 28.2292 39.3297 28.4202V47.2902C39.3297 47.4812 39.2538 47.6643 39.1188 47.7993C38.9838 47.9343 38.8006 48.0102 38.6097 48.0102H17.1497C16.9587 48.0102 16.7756 47.9343 16.6406 47.7993C16.5055 47.6643 16.4297 47.4812 16.4297 47.2902V28.4202C16.4297 28.2292 16.5055 28.0461 16.6406 27.9111C16.7756 27.7761 16.9587 27.7002 17.1497 27.7002Z",
    fill: "#485CC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2514 27.7002H33.6114V21.0502C33.6201 19.5569 33.0454 18.1191 32.0097 17.0432C30.974 15.9673 29.5592 15.3382 28.0666 15.29C26.5739 15.2417 25.1215 15.7781 24.0185 16.785C22.9155 17.7918 22.2492 19.1894 22.1614 20.6802V27.6802H19.5114V21.0502C19.4464 18.8304 20.2659 16.6756 21.7897 15.06C23.3134 13.4444 25.4165 12.5002 27.6364 12.4352C29.8563 12.3703 32.011 13.1898 33.6266 14.7135C35.2423 16.2372 36.1864 18.3404 36.2514 20.5602V27.7002Z",
    fill: "#485CC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0409 50.5498H22.2109V51.3698H50.0409V50.5498Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3919 30.79H46.8519C47.0428 30.79 47.226 30.8659 47.361 31.0009C47.496 31.1359 47.5719 31.3191 47.5719 31.51V50.38C47.5719 50.571 47.496 50.7541 47.361 50.8892C47.226 51.0242 47.0428 51.1 46.8519 51.1H25.3919C25.2009 51.1 25.0178 51.0242 24.8828 50.8892C24.7477 50.7541 24.6719 50.571 24.6719 50.38V31.51C24.6719 31.3191 24.7477 31.1359 24.8828 31.0009C25.0178 30.8659 25.2009 30.79 25.3919 30.79Z",
    fill: "#A7E2F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4897 30.7901H41.8497V24.1401C41.8583 22.6467 41.2836 21.2089 40.248 20.133C39.2123 19.0571 37.7975 18.428 36.3048 18.3798C34.8122 18.3316 33.3597 18.868 32.2568 19.8748C31.1538 20.8816 30.4874 22.2793 30.3997 23.7701V30.7701H27.7497V24.1401C27.7175 23.0409 27.9021 21.9462 28.2931 20.9184C28.684 19.8906 29.2735 18.9498 30.028 18.1498C30.7824 17.3499 31.6871 16.7063 32.6903 16.256C33.6935 15.8056 34.7755 15.5572 35.8747 15.5251C36.9738 15.4929 38.0686 15.6775 39.0964 16.0684C40.1242 16.4593 41.0649 17.0489 41.8649 17.8033C42.6649 18.5578 43.3084 19.4625 43.7588 20.4657C44.2092 21.4688 44.4575 22.5509 44.4897 23.6501V30.7901Z",
    fill: "#77D9F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2111 38.8499C38.2067 38.4967 38.1129 38.1504 37.9384 37.8432C37.764 37.5361 37.5145 37.2782 37.2133 37.0936C36.9121 36.9091 36.5691 36.8038 36.2162 36.7878C35.8633 36.7718 35.5121 36.8454 35.1955 37.0019C34.8788 37.1583 34.6069 37.3925 34.4053 37.6826C34.2036 37.9726 34.0788 38.309 34.0424 38.6603C34.006 39.0117 34.0592 39.3665 34.1972 39.6917C34.3351 40.0169 34.5532 40.3019 34.8311 40.5199V44.3299H37.4111V40.5199C37.6649 40.3228 37.8694 40.0692 38.0082 39.7793C38.1471 39.4895 38.2165 39.1713 38.2111 38.8499Z",
    fill: "#485CC7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 13.9688,
    y1: 47.87,
    x2: 41.7888,
    y2: 47.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 362.015,
    y1: 361.362,
    x2: 1136.25,
    y2: 361.362,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectApps);
export default __webpack_public_path__ + "static/media/connect-apps.b0f2adae64b3e2debe6c3ec505831000.svg";
export { ForwardRef as ReactComponent };